import {
  ICheckBoxObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import { PaintStyle } from "../../../../domain/drawing";
import {
  CheckBoxItem,
} from "../../../../domain/document/items";
import { AbstractObjectStyleReader } from "./AbstractObjectStyleReader";
import { FixedColorSource } from "./FixedColorSource";

export class CheckBoxObjectStyleReader extends AbstractObjectStyleReader<CheckBoxItem> {
  constructor(private readonly _configuration: ICheckBoxObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: CheckBoxItem): PaintStyle {
    return null;
  }

  protected readBackgroundColorConfiguration(source: CheckBoxItem): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  protected readBorderColorConfiguration(source: CheckBoxItem): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  private readObjectStyleConfiguration(source: CheckBoxItem): IObjectColorConfiguration {
    if ((source.injectedRule && source.injectedRule.isEditDisabled) || !source.isFreeInputable) {
      return FixedColorSource.uneditableCheckBox;
    }
    return source.shouldDrawBorder
      ? this._configuration.default
      : this._configuration.borderless;
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return null;
  }
}
